<div class="flex min-h-dvh justify-center items-center text-base max-w-[400px]">
  <app-card>
    <div class="px-4 py-8">
      <img
        src="/assets/images/logo.png"
        alt=""
        class="w-3/5 m-auto mb-8"
      />

      <section class="flex flex-col justify-center items-center">
        <span class="text-2xl font-medium mb-3 text-center">{{ title() }}</span>
        <span class="text-base mb-8 text-center font-light text-gray-600">{{ description() }}</span>
      </section>

      <ng-content></ng-content>
    </div>
  </app-card>
</div>
